import React from 'react';

class TimelineEventErrorHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: false};
  }
  componentDidCatch(error) {
    console.log('Timeline failed to render: ', error);
    this.setState({error: true});
  }
  render() {

    if (this.state.error || this.props.error) {
      //ignore timeline event that failed to render or parse
      return null;
    }
    return this.props.children;
  }
}

export default TimelineEventErrorHandler;
